
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare-energy-rates-2",
      function () {
        return require("private-next-pages/compare-energy-rates-2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare-energy-rates-2"])
      });
    }
  